export default "__VITE_ASSET__1f93b0c4__"